import { render, staticRenderFns } from "./parameters-edition-component.vue?vue&type=template&id=dcb01004&scoped=true&"
import script from "./parameters-edition-component.vue?vue&type=script&lang=ts&"
export * from "./parameters-edition-component.vue?vue&type=script&lang=ts&"
import style0 from "./parameters-edition-component.vue?vue&type=style&index=0&id=dcb01004&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb01004",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VForm,VIcon})
